export default function Recipe({ content, rating }) {
  const {
    title,
    description,
    datePublished,
    recipeIngredient,
    recipeInstructions,
    path,
    SEOImage,
    recipeYield,
    prepTime,
    cookTime,
    totalTime,
    keywords,
    recipeCategory,
    recipeCuisine,
    hasSections,
    sections,
    calories,
    fats,
    proteins,
    carbs,
    fiber,
    video,
  } = content
  const { ratingValue, reviewCount, bestRating, worstRating } = rating
  let ingredients = []
  if (hasSections) {
    for (let i = 0; i < sections.length; i++) {
      ingredients = ingredients.concat(sections[i].ingredients)
    }
    ingredients = `"${ingredients.join('","')}"`
  } else {
    ingredients = `"${recipeIngredient.join('","')}"`
  }
  const keywordsJoined = `"${keywords.join('","')}"`
  const images = `"${SEOImage.join('","')}"`
  const categories = `"${recipeCategory.join('","')}"`
  const cuisine = `"${recipeCuisine ? recipeCuisine.join('","') : "American"}"`
  const instructions = `"${recipeInstructions.join('","')}"`
  const data = `{
    "@context":"http://schema.org/",
    "@type":"Recipe",
    "name":"${title}",
    "author": {
      "@type":"Person",
      "name":"Giselle Santín",
      "url":"http://www.vivelowcarb.com/aboutme"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue":"${ratingValue}",
      "reviewCount":"${reviewCount}",
      "bestRating":"${bestRating}",
      "worstRating":"${worstRating}"
    },
    "image":[
      ${images}
    ],
    "url":"http://www.vivelowcarb.com${path}",
    "description": "${description}",
    "datePublished": "${datePublished}",
    "recipeIngredient": [
      ${ingredients}
    ],
    "recipeInstructions": [
      ${instructions}
    ],
    "recipeYield":"${recipeYield}",
    "prepTime":"${prepTime}",
    "cookTime":"${cookTime}",
    "totalTime":"${totalTime}",
    "keywords":[${keywordsJoined}],
    "recipeCategory":[${categories}],
    "recipeCuisine":[${cuisine}],
    "video":{
      "@type":"VideoObject",
      "name":"${title}",
      "description":"${description}",
      "embedUrl":"https://www.youtube.com/embed/${video}?feature=oembed",
      "contentUrl":"https://www.youtube.com/watch?v=${video}",
      "thumbnailUrl":["https://i.ytimg.com/vi/${video}/hqdefault.jpg"],
      "uploadDate":"${datePublished}"},
    "nutrition": {
      "@type": "nutritionInformation",
      "calories": "${calories} kcal",
      "carbohydrateContent": "${carbs} g",
      "fiberContent": "${fiber} g",
      "fatContent": "${fats} g",
      "proteinContent": "${proteins} g"
    }
  }`
  return data
}
